import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const HotspotToolbar = ({ onTypeSelect, selectedType }) => {
  const { t } = useTranslation();

  const hotspotTypes = [
    {
      id: 'link',
      name: t('catalogEditor.hotspotToolbar.link'),
      icon: 'Link',
      description: t('catalogEditor.hotspotToolbar.linkDesc'),
      color: 'bg-blue-500'
    },
    {
      id: 'buy',
      name: t('catalogEditor.hotspotToolbar.buy'),
      icon: 'ShoppingCart',
      description: t('catalogEditor.hotspotToolbar.buyDesc'),
      color: 'bg-green-500'
    },
    {
      id: 'info',
      name: t('catalogEditor.hotspotToolbar.info'),
      icon: 'Info',
      description: t('catalogEditor.hotspotToolbar.infoDesc'),
      color: 'bg-purple-500'
    },
    {
      id: 'image',
      name: t('catalogEditor.hotspotToolbar.image'),
      icon: 'Image',
      description: t('catalogEditor.hotspotToolbar.imageDesc'),
      color: 'bg-orange-500'
    },
    {
      id: 'video',
      name: t('catalogEditor.hotspotToolbar.video'),
      icon: 'Video',
      description: t('catalogEditor.hotspotToolbar.videoDesc'),
      color: 'bg-red-500'
    },
    {
      id: 'internal_link',
      name: t('catalogEditor.hotspotToolbar.internalLink'),
      icon: 'ArrowRight',
      description: t('catalogEditor.hotspotToolbar.internalLinkDesc'),
      color: 'bg-teal-500'
    }
  ];

  return (
    <div className="bg-card border-b border-border">
      <div className="px-4 md:px-6 py-3 md:py-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4">
          {t('catalogEditor.hotspotToolbar.title')}
        </h3>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-rows-2 gap-2 md:gap-3">
          {hotspotTypes?.map((type) => (
            <button
              key={type?.id}
              onClick={() => onTypeSelect(type?.id)}
              className={`flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg border-2 transition-all duration-200 ${
                selectedType === type?.id
                  ? 'border-accent bg-accent/10' :'border-border hover:border-accent/50 hover:bg-muted/50'
              }`}
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${type?.color} flex items-center justify-center`}>
                <Icon name={type?.icon} size={20} className="text-white" />
              </div>
              <div className="text-center">
                <div className="text-xs md:text-sm font-medium text-foreground">
                  {type?.name}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                  {type?.description}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotspotToolbar;
